import { BaseCommand } from "./baseCommand.js";
export class CommonCommand extends BaseCommand {
  /**
   * 创建通用的历史记录
   * @param {Object} state 存储一些undo和redo需要的数据，比如需要修改的对象、修改前的数据、修改后的数据等
   * @param {*} undoCB undo回调
   * @param {*} redoCB redo回调
   */
  constructor(state, undoCB, redoCB) {
    super();
    this.type = "CommonCommand";
    this.state = state;
    this.undoCB = undoCB;
    this.redoCB = redoCB;
  }

  undo() {
    super.undo();
    if (this.undoCB) this.undoCB(this.state);
  }

  redo() {
    super.redo();
    if (this.redoCB) this.redoCB(this.state);
  }

  clear() {
    this.state = null;
    this.undoCB = null;
    this.redoCB = null;
  }
}
